import React from 'react';
import Button from '@material-ui/core/Button';
import { Box, Typography, Dialog } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import { useStyles } from './styles';

export const ModalWithConfirmation = (props: any) => {
  // TO DO add Props type and snackbar optional
  const {
    onClose,
    isOpen,
    onConfirm,
    onCancel,
    title,
    text,
    href,
    confirmBtnLabel,
    cancelBtnlabel,
    snackbar,
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} classes={{ paper: classes.paper }}>
      <>
        <div className={classes.topSection}>
          <Typography className={classes.title} variant="h2" paragraph>
            {title}
          </Typography>
          <Typography variant="body1" className={classes.description}>
            {text}
          </Typography>
          {snackbar}
        </div>
        <Box className={classes.bottomSection}>
          {href ? (
            <Button
              className={classes.submitButton}
              color="primary"
              variant="contained"
              href={href}
              target="_blank"
              onClick={onConfirm}
            >
              {confirmBtnLabel}
            </Button>
          ) : (
            <Button
              className={classes.submitButton}
              color="primary"
              variant="contained"
              onClick={onConfirm}
            >
              {confirmBtnLabel}
            </Button>
          )}
          <MuiLink
            component="a"
            variant="body2"
            className={classes.links}
            onClick={onCancel}
          >
            {cancelBtnlabel}
          </MuiLink>
        </Box>
      </>
    </Dialog>
  );
};
